import {Component} from '@angular/core';
import {DxTabsModule} from "devextreme-angular";
import {FacilityUtilizationComponent} from "./facility-utilization/facility-utilization.component";
import {CountsPerStorageTypeComponent} from "./counts-per-storage-type/counts-per-storage-type.component";
import {CountsPerPalletTypeComponent} from "./counts-per-pallet-type/counts-per-pallet-type.component";
import {FacilityUtilizationScoreComponent} from "./facility-utilization-score/facility-utilization-score.component";

@Component({
    selector: 'app-inventory-utilization',
    imports: [DxTabsModule, FacilityUtilizationComponent, CountsPerStorageTypeComponent, CountsPerPalletTypeComponent, FacilityUtilizationScoreComponent],
    templateUrl: './inventory-utilization.component.html'
})
export class InventoryUtilizationComponent {
    tabs = [
        {text: 'My Score', id: 0},
        {text: 'Daily Score', id: 1},
        {text: 'Storage Type', id: 2},
        {text: 'ST Category', id: 3}
    ];

    selectedTabKeys = [this.tabs[0].id];
}
